// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"adf6a495","239":"d038936e","455":"c498c9c1"}[chunkId] + ".chunk.js";
};